
export enum ARDebtorCd {
	AR_COLL_DEBTOR = 'ArCollDebtor',
	AR_PPD_DEBTOR = 'ArPpdDebtor'}

